var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavLeftLanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5233 15.1666L16.9933 10.6966L15.815 9.51831L9.33329 16L15.815 22.4816L16.9933 21.3033L12.5233 16.8333H22.6666V15.1666H12.5233Z",
    fill: "url(#paint0_linear_26944_2629)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "matrix(-1 0 0 1 31 0)",
    stroke: "url(#paint1_linear_26944_2629)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26944_2629",
    x1: 16,
    y1: 9.51831,
    x2: 16,
    y2: 22.4816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E80088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26944_2629",
    x1: 52,
    y1: 11.2,
    x2: -8.4,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E80088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642C8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavLeftLanding);
export default __webpack_public_path__ + "static/media/icon_nav_left_landing.14eba56b866d73d8b0ccaf6115576a80.svg";
export { ForwardRef as ReactComponent };